var map = {
	"./ad.svg": 68112,
	"./al.svg": 69254,
	"./am.svg": 61107,
	"./at.svg": 29125,
	"./az.svg": 34590,
	"./ba.svg": 52499,
	"./be.svg": 87461,
	"./bg.svg": 97116,
	"./by.svg": 78634,
	"./ch.svg": 96424,
	"./cy.svg": 23004,
	"./cz.svg": 30727,
	"./de.svg": 83648,
	"./dk.svg": 55841,
	"./ee.svg": 91219,
	"./es.svg": 78105,
	"./fi.svg": 62844,
	"./fr.svg": 45257,
	"./gb-eng.svg": 58800,
	"./gb-sct.svg": 20548,
	"./gb-wls.svg": 42163,
	"./gb.svg": 41017,
	"./ge.svg": 27651,
	"./gr.svg": 56612,
	"./hr.svg": 52375,
	"./hu.svg": 94813,
	"./it.svg": 80643,
	"./kz.svg": 90620,
	"./lt.svg": 55737,
	"./lv.svg": 15946,
	"./me.svg": 22642,
	"./nl.svg": 71263,
	"./no.svg": 29810,
	"./pl.svg": 97032,
	"./pt.svg": 2607,
	"./rs.svg": 50474,
	"./se.svg": 42539,
	"./si.svg": 76299,
	"./sk.svg": 96431,
	"./tr.svg": 46135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96558;